var path = 'public/app/partials/edit_json.html';
var html = "<div ng-controller=JsonEditorCtrl>\n\t<div class=tabbed-view-header>\n\t\t<h2 class=tabbed-view-title>\n\t\t\tJSON\n\t\t</h2>\n\n\t\t<button class=tabbed-view-close-btn ng-click=dismiss()>\n\t\t\t<i class=\"fa fa-remove\"></i>\n\t\t</button>\n\t</div>\n\n\t<div class=tabbed-view-body>\n\t\t<div class=gf-form>\n\t\t\t<textarea class=gf-form-input ng-model=json rows=20 spellcheck=false></textarea>\n\t\t</div>\n\n\t\t<div class=gf-form-button-row>\n\t\t\t<button type=button class=\"btn btn-success\" ng-show=canUpdate ng-click=\"update(); dismiss();\">Update</button>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/partials/edit_json.html
// module id = 616
// module chunks = 5